import api from './api';

const parseSetupIntent = (setupIntent: { payment_method: string }) => ({
  payment_method_id: setupIntent.payment_method,
});

const getSetupIntentToken = async () => {
  const { data } = await fetchSetupIntentToken();
  return data?.client_secret;
};

const fetchSetupIntentToken = async () => api.post('users/payment-session');

export default { parseStripeToken: parseSetupIntent, getSetupIntentToken };
